export const ApiDef_RuntimeProtocol = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map